module.exports = __webpack_public_path__ + "static/media/onoake-preview.87bafef7.png";